'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialDribbbleOutline = function IoSocialDribbbleOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 5c8.3 0 15 6.7 15 15s-6.7 15-15 15-15-6.7-15-15 6.7-15 15-15z m9.5 6.9c-1.3 1.9-3.6 3.6-6.6 5 0.4 0.8 0.7 1.5 1 2.4 2.6-0.2 5.9-0.3 8.6-0.2-0.2-2.7-1.2-5.3-3-7.2z m-9.5-4.4c-1.1 0-2 0.2-3 0.4 1.8 1.8 3.3 4.1 4.8 6.8 2.7-1.1 4.8-2.6 6.2-4.3-2.2-1.8-5-2.9-8-2.9z m-5.6 1.4c-3.2 1.6-5.6 4.5-6.5 8.1h1.9c3.5 0 6.7-0.5 9.5-1.4-1.5-2.6-3.1-4.9-4.9-6.7z m-6.9 10.5v0.6c0 3.1 1.2 6.1 3.1 8.3 1.9-3.5 5.3-6.5 9.6-8.3 0.3-0.2 0.6-0.2 1.1-0.3-0.3-0.6-0.5-1.3-0.8-1.9-3.2 1-6.9 1.6-10.8 1.7-0.7 0-1.5-0.1-2.2-0.1z m12.5 13.1c1.6 0 3-0.2 4.5-0.8-0.3-1.9-0.7-4.1-1.2-6.2-0.3-1.3-0.8-2.5-1.3-3.8-0.5 0.2-1 0.3-1.3 0.5-3.7 1.7-6.7 4.4-8.4 7.6 2.2 1.7 4.8 2.7 7.7 2.7z m6.7-2c3.1-2.1 5.3-5.3 5.7-9.1-2.3-0.1-5.3-0.2-7.7 0 0.3 0.9 0.7 2 0.9 3 0.6 2.1 0.9 4 1.1 6.1z' })
        )
    );
};

exports.default = IoSocialDribbbleOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-dribbble-outline.js
// module id = 2666
// module chunks = 0